module.exports = __webpack_public_path__ + "img/header-right.000b5486.png";